
import React from "react";
import { Routes, Route } from "react-router-dom";
import StaffList from "pages/User/Staff/List";
import PartnerList from "pages/User/Partner/List";
import MemberList from "pages/User/Member/List";

const UserRoute = () => (
    <Routes>
        <Route path="/staff" element={<StaffList />}></Route>
        <Route path="/partner" element={<PartnerList />}></Route>
        <Route path="/member" element={<MemberList />}></Route>
    </Routes>
)

export default UserRoute;